/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { useEffect } from 'react'

const BASE = { o: { d: 'out-in', l: 10, r: { start: 0, end: 27 } } }
const EFFECTS = [
  { sel: '.lp-bar', o: { d: 'in-out', l: 10, r: { start: 89, end: 100 } } },
  { sel: '.lp-foot-m-logo-c', o: BASE.o, sc: { d: 'out-in', s: 2, r: { start: 0, end: 34 } } },
  { sel: '.lp-foot-col-l', o: BASE.o },
  { sel: '.lp-foot-col-c', o: BASE.o },
  { sel: '.lp-foot-logo-c', o: BASE.o, sc: { d: 'out-in', s: 2, r: { start: 0, end: 34 } } },
  { sel: '.lp-foot-col-r', o: BASE.o },
]

const pct = (span, v) => +((v / span) * 100).toFixed(2)

function phase(p, dir, range) {
  let o
  if (p < range.start) {
    o = dir === 'out-in' ? 0 : dir === 'in-out' ? 100 : pct(range.start, p)
    if (dir === 'in-out-in') o = 100 - o
  } else if (p < range.end) {
    o = dir === 'in-out-in' ? 0 : dir === 'out-in-out' ? 100 : pct(range.end - range.start, p - range.start)
    if (dir === 'in-out') o = 100 - o
  } else {
    o = dir === 'in-out' ? 0 : dir === 'out-in' ? 100 : pct(100 - range.end, 100 - p)
    if (dir === 'in-out-in') o = 100 - o
  }
  return o
}

function progress(el) {
  const rect = el.getBoundingClientRect()
  const cs = getComputedStyle(el)
  const vh = window.innerHeight
  const h = rect.height - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom) - parseFloat(cs.borderTopWidth) - parseFloat(cs.borderBottomWidth)
  const a = -(rect.top - vh)
  const s = rect.top + h - (rect.top - vh)
  return +(100 * Math.max(0, Math.min(a / s, 1))).toFixed(2)
}

export default function useMotion() {
  useEffect(() => {
    const items = EFFECTS.map((c) => {
      const el = document.querySelector(c.sel)
      return el && el.parentElement ? { el, parent: el.parentElement, c } : null
    }).filter(Boolean)
    if (!items.length) return undefined
    let tick = 0
    const run = () => {
      tick = 0
      items.forEach(({ el, parent, c }) => {
        const p = progress(parent)
        el.style.setProperty('--e-transform-transition-duration', '100ms')
        if (c.o) {
          const i = c.o.l / 10
          el.style.opacity = 1 - i + (i * phase(p, c.o.d, c.o.r)) / 100
          el.style.willChange = 'opacity'
        }
        if (c.sc) el.style.transform = 'scale(' + (1 + (c.sc.s * phase(p, c.sc.d, c.sc.r)) / 1000) + ')'
      })
    }
    const onScroll = () => {
      if (!tick) tick = requestAnimationFrame(run)
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
    run()
    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
      if (tick) cancelAnimationFrame(tick)
    }
  }, [])
}
